import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaCalendarDay } from "react-icons/fa6";
import Awards from "./index";
import ViewHoliday from "./view";
import EditAward from "./edit";

import { MODULE_AWARDS } from "variables/modules";

const awardsRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Awards",
		basePath: "awards",
		mainComponent: <Awards />,
	    layout: "/console",	   
	    icon: <FaCalendarDay className="icon-item" />,
	    subTitle:"Awards",
	    createComponent: <EditAward />,
	    editComponent: <EditAward />,
		level:3,
		moduleId: MODULE_AWARDS,
	})
]

export default awardsRoutes;